import { useQuery } from "@apollo/client";
import { ReactNode, createContext, useContext, useMemo } from "react";
import { GET_MODULES_INFO } from "../api";
import { GetModulesInfoQuery } from "gql/graphql";

type ContextProps = { modules: GetModulesInfoQuery["getModulesInfo"] };

export const ModuleContext = createContext<ContextProps>({ modules: [] });

export function ModuleProvider({ children }: { children: ReactNode }) {
  const { data } = useQuery(GET_MODULES_INFO);

  const value = useMemo(() => {
    return { modules: data?.getModulesInfo };
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <ModuleContext.Provider value={value}>{children}</ModuleContext.Provider>
  );
}

export function useModuleContext() {
  return useContext(ModuleContext);
}
